<div class="action-menu">
  <button
    type="button"
    class="menu-trigger"
    [attr.data-testid]="testId + '-trigger'"
    [matMenuTriggerFor]="actionMenu"
    (menuOpened)="menuOpened.emit()"
    (click)="$event.stopPropagation()"
    [attr.aria-label]="ariaLabel"
  >
    <img src="assets/images/package/dots-vertical.svg" alt="" />
  </button>
</div>

<mat-menu #actionMenu="matMenu" panelClass="package-row-action-menu" xPosition="before">
  <div class="action-menu-content">
    @for (item of items; track item.id) {
      <button
        type="button"
        class="action-menu-item"
        [class.delete-item]="item.danger"
        [class.border-top]="item.borderTop"
        [class.border-both]="item.borderBoth"
        [attr.data-testid]="testId + '-item-' + item.id"
        (click)="onSelect(item.id)"
      >
        <span>{{ item.label }}</span>
        <img
          [src]="item.icon"
          alt=""
          [attr.width]="item.iconSize || 12"
          [attr.height]="item.iconSize || 12"
        />
      </button>
    }
  </div>
</mat-menu>
